<div class="issue-repair-detail-scroll-wrapper" [testId]="'issue-repair-detail-scroll-wrapper'">
  <div class="issue-repair-detail" [testId]="'issue-repair-detail'">
    <!-- 頂部返回區域 -->
    <div class="header-section" [testId]="'header-section'">
      <div class="back-section" [testId]="'back-section'">
        <button nz-button nzType="text" (click)="goBack()" class="back-button" [testId]="'back-button'">
          <i nz-icon nzType="left" [testId]="'back-icon'"></i>
        </button>
        <h3 class="issue-title" [testId]="'issue-title'">{{ issueData?.name }}</h3>
      </div>
    </div>

    <!-- 詳情表單區域 -->
    <div class="form-container" *ngIf="issueData" [testId]="'form-container'">
      <form nz-form [nzLayout]="'horizontal'" class="detail-form" [testId]="'detail-form'">
        <!-- 標題和狀態 -->
        <div class="form-row" [testId]="'title-status-row'">
          <div class="form-col-half" [testId]="'title-col'">
            <nz-form-item [testId]="'title-form-item'">
              <nz-form-label [testId]="'title-label'">{{ 'issue-repair.table.title' | i18n }}</nz-form-label>
              <nz-form-control [testId]="'title-control'">
                <input nz-input [value]="issueData.name" readonly class="readonly-field" [testId]="'title-input'" />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div class="form-col-half" [testId]="'status-col'">
            <nz-form-item [testId]="'status-form-item'">
              <nz-form-label [testId]="'status-label'">{{ 'issue-repair.table.status' | i18n }}</nz-form-label>
              <nz-form-control [testId]="'status-control'">
                <input nz-input [value]="issueData.status" readonly class="readonly-field" [testId]="'status-input'" />
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <nz-divider />
        <!-- 問題編號和報修時間 -->
        <div class="form-row" [testId]="'issue-time-row'">
          <div class="form-col-half" [testId]="'issue-number-col'">
            <nz-form-item [testId]="'issue-number-form-item'">
              <nz-form-label [testId]="'issue-number-label'">{{ 'issue-repair.table.issue-number' | i18n }}</nz-form-label>
              <nz-form-control [testId]="'issue-number-control'">
                <input nz-input [value]="issueData.issueNumber" readonly class="readonly-field" [testId]="'issue-number-input'" />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div class="form-col-half" [testId]="'repair-time-col'">
            <nz-form-item [testId]="'repair-time-form-item'">
              <nz-form-label>{{ 'issue-repair.table.issue-time' | i18n }}</nz-form-label>
              <nz-form-control [testId]="'repair-time-control'">
                <input
                  nz-input
                  [value]="issueData.issueTime | date: 'yyyy-MM-dd HH:mm'"
                  readonly
                  class="readonly-field"
                  testId="repair-time-input"
                />
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <!-- 租戶名稱和報修人 -->
        <div class="form-row" [testId]="'tenant-reporter-row'">
          <div class="form-col-half" [testId]="'tenant-name-col'">
            <nz-form-item [testId]="'tenant-name-form-item'">
              <nz-form-label [testId]="'tenant-name-label'">{{ 'issue-repair.table.tenant-name' | i18n }}</nz-form-label>
              <nz-form-control [testId]="'tenant-name-control'">
                <input nz-input [value]="issueData.tenantName || ''" readonly class="readonly-field" [testId]="'tenant-name-input'" />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div class="form-col-half" [testId]="'reporter-col'">
            <nz-form-item [testId]="'reporter-form-item'">
              <nz-form-label>{{ 'issue-repair.table.issue-time' | i18n }}</nz-form-label>
              <nz-form-control [testId]="'repair-time-control'">
                <input
                  nz-input
                  [value]="issueData.issueTime | date: 'yyyy-MM-dd HH:mm'"
                  readonly
                  class="readonly-field"
                  [testId]="'repair-time-input'"
                />
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div class="form-row" [testId]="'contact-phone-row'">
          <div class="form-col-single" [testId]="'contact-phone-col'">
            <nz-form-item [testId]="'contact-phone-form-item'">
              <nz-form-label [testId]="'contact-phone-label'">{{ 'issue-repair.detail.contact-phone' | i18n }}</nz-form-label>
              <nz-form-control [testId]="'contact-phone-control'">
                <input nz-input [value]="issueData.mobile || ''" readonly class="readonly-field" [testId]="'contact-phone-input'" />
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <nz-divider />
        <!-- 問題類型 -->
        <div class="form-row" [testId]="'type-platform-row'">
          <div class="form-col-half" [testId]="'issue-type-col'">
            <nz-form-item [testId]="'issue-type-form-item'">
              <nz-form-label [testId]="'issue-type-label'">{{ 'issue-repair.table.type' | i18n }}</nz-form-label>
              <nz-form-control [testId]="'issue-type-control'">
                <input nz-input [value]="issueData.type" readonly class="readonly-field" [testId]="'issue-type-input'" />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div class="form-col-half" [testId]="'platform-col'">
            <nz-form-item [testId]="'platform-form-item'">
              <nz-form-label [testId]="'platform-label'">{{ 'issue-repair.table.platform' | i18n }}</nz-form-label>
              <nz-form-control [testId]="'platform-control'">
                <input nz-input [value]="issueData.deviceType" readonly class="readonly-field" [testId]="'platform-input'" />
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <!-- 問題描述（單獨一行） -->
        <div class="form-row" [testId]="'description-row'">
          <div class="form-col-full" [testId]="'description-col'">
            <nz-form-item [testId]="'description-form-item'">
              <nz-form-label [testId]="'description-label'">{{ 'issue-repair.detail.description' | i18n }}</nz-form-label>
              <nz-form-control [testId]="'description-control'">
                <textarea nz-input [value]="issueData.explain" readonly class="readonly-field" [testId]="'description-textarea'"></textarea>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <!-- 附件區域 -->
        <div class="form-row" *ngIf="issueData.attachmentInfos" [testId]="'attachments-row'">
          <div class="form-col-full" [testId]="'attachments-col'">
            <nz-form-item [testId]="'attachments-form-item'">
              <nz-form-label [testId]="'attachments-label'">{{ 'issue-repair.detail.attachments' | i18n }}</nz-form-label>
              <nz-form-control [testId]="'attachments-control'">
                <div class="attachment-content" [testId]="'attachment-content'">
                  <div class="attachment-list" [testId]="'attachment-list'">
                    <div
                      class="attachment-item"
                      *ngFor="let attachment of issueData.attachmentInfos"
                      [testId]="'attachment-item-' + attachment.id"
                    >
                      <i nz-icon [nzType]="'paper-clip'" class="file-icon" [testId]="'file-icon-' + attachment.id"></i>
                      <span class="file-name" (click)="previewAttachment(attachment)" [testId]="'file-name-' + attachment.id">{{
                        attachment.originalFullName
                      }}</span>
                      <i
                        nz-icon
                        nzType="download"
                        class="download-icon"
                        (click)="downloadFile(attachment.id, attachment.originalFullName)"
                        [testId]="'download-icon-' + attachment.id"
                      ></i>
                    </div>
                  </div>
                </div>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </form>
    </div>

    <!-- 載入中狀態 -->
    <div class="loading-container" *ngIf="loading" [testId]="'loading-container'">
      <nz-spin nzSize="large" [testId]="'loading-spinner'" />
    </div>
  </div>

  <!-- 附件預覽模態框 -->
  <nz-modal
    [testId]="'attachment-preview-modal'"
    [(nzVisible)]="previewVisible"
    [nzTitle]="('issue-repair.detail.attachment-preview' | i18n) + ' - ' + (currentAttachment?.originalFullName || '')"
    [nzFooter]="null"
    [nzWidth]="800"
    (nzOnCancel)="closePreview()"
    nzCentered
  >
    <ng-container *nzModalContent [testId]="'modal-content'">
      <div class="preview-container" *ngIf="currentAttachment" [testId]="'preview-container'">
        <!-- 圖片預覽 -->
        <div *ngIf="isImage(currentAttachment.type)" class="image-preview" [testId]="'image-preview'">
          <img
            [src]="getFileUrl(currentAttachment.id)"
            [alt]="currentAttachment.originalFullName"
            class="preview-image"
            [testId]="'preview-image'"
          />
        </div>

        <!-- PDF預覽 -->
        <div *ngIf="isPdf(currentAttachment.extension)" class="pdf-preview" [testId]="'pdf-preview'">
          <iframe [src]="getFileUrl(currentAttachment.id)" class="preview-iframe" [testId]="'preview-iframe'"></iframe>
        </div>

        <!-- 其他文件類型 -->
        <div *ngIf="!isImage(currentAttachment.type) && !isPdf(currentAttachment.extension)" class="file-preview" [testId]="'file-preview'">
          <div class="file-info" [testId]="'file-info'">
            <i nz-icon [nzType]="'paper-clip'" class="large-file-icon" [testId]="'large-file-icon'"></i>
            <h4 [testId]="'file-name-title'">{{ currentAttachment.name }}</h4>
            <p [testId]="'file-size-info'">{{ 'issue-repair.detail.file-size' | i18n }}: {{ formatFileSize(currentAttachment.size) }}</p>
            <p [testId]="'preview-not-supported-message'">{{ 'issue-repair.detail.preview-not-supported' | i18n }}</p>
            <button
              nz-button
              nzType="primary"
              (click)="downloadFile(currentAttachment.id, currentAttachment.originalFullName)"
              [testId]="'download-file-button'"
            >
              <i nz-icon nzType="download" [testId]="'download-button-icon'"></i>
              {{ 'issue-repair.detail.download-file' | i18n }}
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </nz-modal>
</div>
